import { Levels } from '@services/data-access';

export function reducerDataLevels(data: any) {
  const dataTemp: { [id: string]: Levels[] } = {};
  const allLevels: { [id: string]: Levels } = {};
  data.curriculums_levels.forEach(
    (item: {
      curriculumId: string | number;
      level: {
        id: any;
        abbreviation?: string;
        createdAt?: any;
        createdBy?: any;
        name?: string;
        status?: string;
        updatedAt?: any;
        updatedBy?: any;
      };
    }) => {
      if (!dataTemp.hasOwnProperty(item.curriculumId)) {
        dataTemp[item.curriculumId] = [];
      }
      dataTemp[item.curriculumId].push(item.level as Levels);

      if (!allLevels.hasOwnProperty(item.level.id)) {
        allLevels[item.level.id] = item.level as Levels;
      }
    },
  );
  dataTemp['root'] = Object.values(allLevels).sort((a: any, b: any) =>
    a.name > b.name ? 1 : -1,
  );
  return dataTemp;
}

const A4inDesign = {
  h: [1240, 595.28],
  v: [1754, 841.89],
};

export function toPrintedPt(pxInDesign: number, direction: 'h' | 'v' = 'v') {
  const [px, mm] = A4inDesign[direction];
  return (((pxInDesign * 1.0) / px) * mm).toFixed(0);
}

export function renderUser(user: any) {
  if (typeof user === 'undefined' || user === null) return '';
  return user.firstName + ' ' + user.lastName;
}

export function sortClassInformation(arr: any = []) {
  return arr
    .slice()
    .sort((a: any, b: any) =>
      (a?.classType ?? '') < (b?.classType ?? '')
        ? 1
        : (b?.classType ?? '') < (a?.classType ?? '')
        ? -1
        : 0,
    );
}

export const convertExpiredDate = (date: string) => {
  if (!date) return '';
  const dateStr = date.replaceAll('/', '');
  const asciiNum: number[] = [];
  dateStr.split('').forEach((_, idx) => {
    if (dateStr.charCodeAt(idx) === 48) {
      asciiNum.push(74); // for case char = 0
    } else {
      asciiNum.push(dateStr.charCodeAt(idx) + 16);
    }
  });
  return String.fromCharCode(...asciiNum);
};
